import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
export function withRouter(Component) {
  const Wrapper = React.forwardRef((props, ref) => {
    const navigate = useNavigate();
    const params = useParams();
    return <Component ref={ref} {...props} navigate={navigate} params={params} />;
  });
  Wrapper.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;
  return Wrapper;
}